import { ICellRendererParams } from 'ag-grid-enterprise'
import { CircleQuestionMark } from 'lucide-react'

import { cn } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Tooltip, TooltipContent, TooltipTrigger } from '@fortem-monorepo/react-ui'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { labels } from '@/pages/funds/ic-report/constants'
import { fundLevel } from '@/react-query/queries/ic-report/hooks'

const colDefs = createColDefs([
  {
    field: 'investment_bucket',
    headerName: 'Attribution',
    cellRenderer: (params: ICellRendererParams) => {
      return params?.node.level === -1 ? (
        <span className={'font-semibold'}>Total</span>
      ) : (
        <Tooltip>
          <TooltipTrigger asChild>
            <div className={'flex items-center gap-2 flex-1 min-w-full!'}>
              <CircleQuestionMark size={16} className={'text-blue-600 shrink-0'} />
              {params.value}
            </div>
          </TooltipTrigger>
          <TooltipContent>
            {
              labels.fund_level.buckets().descriptions[
                params.value as keyof typeof labels.fund_level.buckets
              ]
            }
          </TooltipContent>
        </Tooltip>
      )
    },
  },
  {
    field: '1_month_attributions',
    aggFunc: 'sum',
    headerName: '1m',
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <span
          className={cn({
            ['font-semibold']: params?.node.level === -1,
          })}
        >
          {params?.value ? `${(params?.value * 100).toFixed(2)}%` : params.value}
        </span>
      )
    },
  },
  {
    field: '3_month_attributions',
    aggFunc: 'sum',
    headerName: '3m',
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <span
          className={cn({
            ['font-semibold']: params?.node.level === -1,
          })}
        >
          {params?.value ? `${(params?.value * 100).toFixed(2)}%` : params.value}
        </span>
      )
    },
  },
  {
    field: 'ytd_attributions',
    aggFunc: 'sum',
    headerName: 'YTD',
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <span
          className={cn({
            ['font-semibold']: params?.node.level === -1,
          })}
        >
          {params?.value ? `${(params?.value * 100).toFixed(2)}%` : params.value}
        </span>
      )
    },
  },
])

export interface BucketedAttributionsTableProps extends ICReportTablePrimitive {}

export const BucketedAttributionsTable: React.FC<BucketedAttributionsTableProps> = ({
  params,
  options,
}) => {
  const query = fundLevel.useBucketedAttributions(params)
  const data = query.data

  return <CustomAgGrid rowData={data} columnDefs={colDefs} grandTotalRow={'bottom'} {...options} />
}
